import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { useNavigate } from 'react-router-dom';

const SuccessPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate successful payment - set pro user status
    localStorage.setItem('is_pro_user', 'true');
  }, []);

  const handleContinue = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-emerald-50 flex items-center justify-center py-8 px-4">
      <Card className="max-w-md w-full p-6 sm:p-8 text-center bg-white shadow-xl">
        <div className="mb-6">
          <div className="text-6xl mb-4">🎉</div>
          <h1 
            data-testid="success-title"
            className="text-2xl sm:text-3xl font-bold text-gray-800 mb-3" 
            style={{ fontFamily: 'Space Grotesk, sans-serif' }}
          >
            Payment Successful!
          </h1>
          <p className="text-sm sm:text-base text-gray-600 mb-6 px-2" style={{ fontFamily: 'Inter, sans-serif' }}>
            Welcome to Pro! You now have unlimited access to GMC Apparel Attribute Validator.
          </p>
          <div className="bg-gradient-to-r from-green-500 to-emerald-500 text-white py-3 px-4 sm:px-6 rounded-full inline-block mb-6">
            <span className="font-semibold text-sm sm:text-base">⭐ Pro User Activated</span>
          </div>
        </div>
        <Button
          data-testid="continue-button"
          onClick={handleContinue}
          size="lg"
          className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white py-5 sm:py-6 text-base sm:text-lg rounded-lg shadow-md transition-all duration-300 hover:scale-[1.02]"
        >
          Start Validating
        </Button>
      </Card>
    </div>
  );
};

export default SuccessPage;
